<template>
    <el-image-viewer v-if="imageList.length" :key="imageIndex" ref="imageViewerRef" :url-list="imageList"
        :initial-index="imageIndex" @close="close"></el-image-viewer>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { StorgeUtils } from "@/utils/StorageUtils";
import Api from "@/http/Api";
export default defineComponent({
    setup() {
        const imageViewerRef = ref()
        const route = useRoute()
        const imageList = ref<string[]>([])
        const imageIndex = ref(0)
        const getImg = async () => {
            let { imgUrl, usertype, accountid, token, recordid, key, index } = route.query
            if (imgUrl) {
                imageList.value = [decodeURIComponent(imgUrl as string)]
            } else if (usertype && accountid && token && recordid && key) {
                StorgeUtils.set("usertype", usertype);
                StorgeUtils.set(usertype === 'college' ? 'accountid' : 'talentAccountid', accountid);
                StorgeUtils.set(usertype === 'college' ? 'token' : 'talentToken', token);
                let signData
                if (usertype == 'college') {
                    signData = await Api.collegeSignUp(recordid)
                } else {
                    signData = await Api.getSignupV3ById(recordid)
                }
                if (signData) {
                    let protocol_photos = [].concat(signData.data?.department_field?.field_data?.[key as string]);
                    console.log('protocol_photos', protocol_photos)
                    if (protocol_photos) {
                        imageList.value = protocol_photos
                    }
                }
                if (index) {
                    imageIndex.value = ~~index

                }
            } else {
                console.error('必要参数不足')
            }
            if (imageViewerRef.value) {
                imageViewerRef.value.setActiveItem(imageIndex.value)
            }
        }
        onMounted(() => {
            if (imageViewerRef.value) {
                imageViewerRef.value.setActiveItem(imageIndex.value)
            }
        })
        const close = () => {
            window.close()
        }
        watch(() => route.query, () => {
            getImg()
        }, { immediate: true, deep: true })
        return { imageList, imageIndex, close }
    }
})
</script>

<style scoped></style>